<template>
  <a-spin tip="Loading..." :spinning="spinning">
    <div class="login-outer">
      <!-- <Header></Header> -->
      <div class="login-inner">
        <div class="login-left">
          <img src="/illustration.png" />
        </div>
        <div class="login-right" :class="{ 'width2': showForget }">
          <img class="logo" v-if="
            $store.state.common.bureau &&
            $store.state.common.bureau.schoolShowType == '1'
          " src="/logo.png" />
          <img class="logo" v-if="
            $store.state.common.bureau &&
            $store.state.common.bureau.schoolShowType == '2'
          " :src="$store.state.common.bureau &&
            $store.state.common.bureau.schoolLogoUrl
            " />
          <div class="desc">
            <span v-if="
              $store.state.common.bureau &&
              $store.state.common.bureau.schoolShowType == '1'
            ">课后三点半</span>
            <p>{{ bureauName }}</p>
            课后服务管理系统
          </div>
          <div v-if="bureauId">
            <a-form class="login-form" @submit="handleSubmit" :form="form" v-if="!showForget">
              <!-- 账号输入 -->
              <template v-if="loginType == '1'">
                <a-form-item class="margin-right-0">
                  <a-input type="text" size="large" placeholder="请输入手机" :maxLength="11" class="login-input-text"
                    v-decorator="[
                      'mobile',
                      {
                        rules: [
                          {
                            required: true,
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号',
                          },
                        ],
                        validateTrigger: 'change',
                      },
                    ]">
                    <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }" />
                  </a-input>
                </a-form-item>

                <!-- 验证码 -->
                <a-form-item class="margin-0">
                  <a-col class="gutter-row" :span="9">
                    <a-form-item class="margin-right-0">
                      <a-input size="large" type="text" placeholder="验证码" :maxLength="4" v-decorator="[
                        'imageCode',
                        {
                          rules: [
                            {
                              required: true,
                              message: '请输入图片验证码',
                            },
                            {
                              pattern: /^.{4}$/,
                              message: '请输入4位验证码',
                            }
                          ],
                          validateTrigger: 'blur',
                        },
                      ]" autocomplete="off" ref="imgCodeRef">
                        <a-icon slot="prefix" type="safety-certificate" :style="{ color: 'rgba(0,0,0,.25)' }" />
                      </a-input>
                    </a-form-item>
                  </a-col>
                  <a-col class="gutter-row" :span="8">
                    <div class="pic">
                      <a @click="getImgCode(true)"><img :src="codeImg" alt=""></a>
                    </div>
                  </a-col>
                  <a-col class="gutter-row" :span="7">
                    <a-button class="getCaptcha" tabindex="-1" :disabled="state.time > 0"
                      @click.stop.prevent="getSmsCode">
                      {{ state.time ? state.time + 's' : '发送短信' }}
                    </a-button>
                  </a-col>
                </a-form-item>
                <a-col class="gutter-row" :span="24">
                  <a-form-item class="margin-right-0">
                    <a-input size="large" type="text" placeholder="短信验证码" :maxLength="6" v-decorator="[
                      'smscode',
                      {
                        rules: [
                          {
                            required: true,
                            pattern: /^\d{6}$/,
                            message: '请输入6位的验证码',
                          },
                        ],
                        validateTrigger: 'blur',
                      },
                    ]" autocomplete="off">
                      <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }" />
                    </a-input>
                  </a-form-item>
                </a-col>
              </template>

              <template v-else>
                <!-- 用户名或密码 -->
                <a-form-item class="margin-right-0">
                  <a-input type="text" placeholder="请输入用户名/手机" size="large" class="login-input-text" v-decorator="[
                    'usernameOrMobile',
                    [{ required: true, message: '请输入用户名或者手机号' }],
                  ]">
                    <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
                  </a-input>
                </a-form-item>

                <!-- 密码 -->
                <a-form-item class="margin-right-0">
                  <a-input type="password" placeholder="请输入密码" size="large" class="login-input-text" v-decorator="[
                    'password',
                    { rules: [{ required: true, message: '请输入密码' }] },
                  ]">
                    <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
                  </a-input>
                </a-form-item>
              </template>
              <!-- 切换另一种登录方式 -->
              <div class="login-type-but">
                <span v-if="loginType == '1'" @click="changeType(2)">密码登录</span>
                <span v-else @click="changeType(1)">验证码登录</span>
                <span @click="fotgetPwd" style="margin-left: 20px;">忘记密码</span>
              </div>

              <!-- 确定登录 -->
              <a-form-item class="margin-right-0" style="margin-top: 16px; margin-bottom: 10px">
                <a-button size="large" type="primary" htmlType="submit" class="login-button">登录</a-button>
              </a-form-item>
            </a-form>
            <!-- 忘记密码 -->
            <a-form class="login-form" @submit="handleSubmit" :form="form" v-else>
              <a-form-item label="管理员手机号" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 17 } }">
                <a-input placeholder="请输入" :maxLength="11" class="w302" v-decorator="[
                  'mobile',
                  { rules: [{ required: true, message: '请输入手机号' }] },
                ]" />
              </a-form-item>
              <!-- 图片验证码 -->
              <a-form-item label="图片验证码" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 7 } }">
                <div class="img-code">
                  <a-input placeholder="请输入" ref="imgCodeRef" v-decorator="[
                    'imageCode',
                    { rules: [{ required: true, message: '请输入图片验证码' }, { pattern: /^.{4}$/, message: '请输入4位验证码' }] },
                  ]" style="width: 110px;" :maxLength="4" autocomplete="off" autocorrect="off" name="img-code" />
                  <div class="pic">
                    <a @click="getImgCode(true)"><img :src="codeImg" alt=""></a>
                  </div>
                  <a-button type="primary" @click="getSmsCode" :disabled="timeCount > 0">
                    {{ timeCount ? timeCount + '秒后再试' : '发送短信' }}
                  </a-button>
                </div>
              </a-form-item>
              <!-- 短信验证码 -->
              <a-form-item label="短信验证码" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 17 } }">
                <a-input placeholder="请输入" class="w302" :maxLength="6" v-decorator="[
                  'smsCode',
                  { rules: [{ required: true, message: '请输入短信验证码' }] },
                ]" autocomplete="off" />
              </a-form-item>
              <!-- 请输入新密码 -->
              <a-form-item label="请输入新密码" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 17 } }">
                <a-input type="password" class="w302" placeholder="请输入" v-decorator="[
                  'password',
                  { rules: [{ required: true, message: '' },{ validator: handleConfirmPass }] },
                ]" autocomplete="new-password" autocorrect="off" name="new-password" />
              </a-form-item>

              <!-- 重复新密码 -->
              <a-form-item label="重复新密码" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 17 } }">
                <a-input type="password" class="w302" placeholder="请输入" v-decorator="[
                  'repeatPassword',
                  { rules: [{ required: true, message: '' },{ validator: handleConfirmPass },{ validator: confirmPassword_rule }] },
                ]" autocomplete="new-password" autocorrect="off" />
              </a-form-item>
              <a-form-item style="width: 428px;">
                <a-button type="primary" @click="confirmUpdate()" style="margin-right: 18px">确认修改</a-button>
                <a-button type="primary" @click="back" style="width: 88px;">返回</a-button>
              </a-form-item>
            </a-form>
          </div>
          <div class="mistake-prompt" v-else>
            <div>当前域名未开通业务，<br></div>
            <div>请检查并联系业务支持：<br></div>
            <div class="domain-name">{{ domainName }}</div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import user from '../../api/user'

import institution from '../../api/institution'
import Vue from 'vue'
import Header from '../../components/Header'
import bureau from '../../api/bureau'
import checkEnv from "../../api/checkEnv"

export default {
  name: 'Login',
  data() {
    return {
      mobile: '',
      password: '',
      bureauId: -11111111,
      state: {
        time: 0,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
      },
      form: this.$form.createForm(this),
      loginType: '2', //1验证码登录，2密码登录
      mode: '',
      spinning: false,
      domainName: location.host,
      bureauName: '',
      codeImg: '',
      showForget: false,
      timeCount: 0,
      sendSuccess: false,
    }
  },
  components: {
    Header,
  },
  methods: {
    //重复密码规则
    confirmPassword_rule(rule, value, callback) {
      if (value && value !== this.form.getFieldValue('password')) {
        callback('两次密码输入不一致')
      } else {
        callback()
      }
    },
    handleConfirmPass(rule, value, callback) {
      if (!value) {
        callback(
          '请输入8-20位密码，需包含大小写字母、数字，字符不支持中文格式。'
        )
      } else if (!/^[\u0020-\u007e]{8,20}$/.test(value)) {
        callback('请输入长度为8~20位的密码')
      } else if (!/[A-Z]+/.test(value)) {
        callback('密码中需要包含大写字母')
      } else if (!/[a-z]+/.test(value)) {
        callback('密码中需要包含小写字母')
      } else if (!/\d+/.test(value)) {
        callback('密码中需要包含数字')
      }
      callback()
    },
    getSmsCode(e) {
      if (this.sendSuccess) return this.$message.error('请勿重复发送')
      setTimeout(() => {
        this.sendSuccess = false
      }, 180000);
      e.preventDefault()
      const {
        form: { validateFields },
        state,
      } = this
      validateFields(['mobile', 'imageCode'], { force: true }, (err, values) => {
        if (!err) {
          let params = {
            mobile: values.mobile,
            mode: this.mode,
            imageCode: values.imageCode,
          }
          user.getSmscode(params).then((res) => {
            this.sendSuccess = true
            const hide = this.$message.loading('验证码发送中..', 0)
            setTimeout(hide, 2500)
            this.state.time = 60
            let timer = setInterval(() => {
              this.state.time--
              if (this.state.time <= 0) {
                clearInterval(timer)
              }
            }, 1000)
          }).catch((err) => {
            console.error('错误信息：', err)
          })
        }
      })
    },

    //登录
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          values.usernameOrMobile = values.usernameOrMobile
            ? values.usernameOrMobile.trim()
            : ''
          let requestFun = this.loginType == '1' ? user.smsLogin : user.login
          requestFun(values).then((res) => {
            //情况缓存
            this.$store.commit('CLEARLOGIN')
            //储存user信息
            this.$ls.set('token', res.accessToken.accessToken)
            this.$ls.set('refreshToken', res.accessToken.refreshToken)
            this.handleRouter()
            // 清除cookie
            user.exit().then((res) => { })
            this.$store.dispatch('getInit').then((res) => {
              console.log('获取的码表信息是：3', res)
              //处理路由

              this.judgeEnter()
            })
          })
        }
      })
    },

    //处理路由
    handleRouter() {
      //点击菜单页权限页面给清除掉
      let routerList = this.$router.options.routes
      window.menuList = []
      if (routerList[0] && routerList[0].children) {
        routerList[0].children = []
      }
      //删除404页面 重新在获取权限的地方在添加路由
      routerList.map((item, index) => {
        if (item.path == '*') {
          routerList.splice(index, 1)
        }
      })
      this.$router.selfaddRoutes(routerList)
    },

    //判断入口
    judgeEnter() {
      this.$store.dispatch('getUserInfo').then((res) => {
        let routerPush = null;
        //如果是课程方
        if (res.accRole.id == 4) {
          institution.getInstitutionByUser().then(async (institutionInfo) => {
            console.log('institutionInfo', institutionInfo)
            if (institutionInfo.data.status == 3) {
              routerPush = 'courseList';
              //this.$router.push('courseList')
            } else if (
              institutionInfo.data.status == 2 ||
              institutionInfo.data.status == 4
            ) {
              this.$store.commit('register/changePage', 4)
              this.$store.commit(
                'register/changeStatus',
                institutionInfo.data.status
              )
              routerPush = 'institutionRegister';
              //this.$router.push('institutionRegister')
            } else if (institutionInfo.data.status == 1) {
              await user
                .getInformation()
                .then((res) => {
                  this.$store.commit('register/changeInformation', res.data)
                })
                .catch((e) => {
                  console.log('e', e)
                })

              this.$store.commit('register/changePage', 3)
              routerPush = 'institutionRegister';
              //this.$router.push('institutionRegister')
            }
            this.nextRoute(routerPush)
          })
        } else if (res.accRole.id == 3) {
          routerPush = 'termSynopsis';
          //this.$router.push('termSynopsis')
        } else {
          routerPush = 'courseList';
          //this.$router.push('courseList')
        }
        this.nextRoute(routerPush)
      })
    },

    doLogin() {
      console.log('dologin')
      let a = location.href.split('&')
      let b = a.map((item) => {
        return item.split('=')
      })
      console.log('b', b)
      if (b[0][1]) {
        //情况缓存
        this.$store.commit('CLEARLOGIN')
        //储存user信息
        this.$ls.set('token', b[0][1])
        this.$ls.set('refreshToken', b[1][1].replaceAll(/#[/\w]+/g, ""))
        //情况缓存
        this.handleRouter()
        // 清除cookie
        user.exit().then((res) => { })
        this.$store.dispatch('getInit').then((res) => {
          console.log('获取的码表信息是：4', res)
          //处理路由，平台管理员可以跳转进入机构管理
          this.judgeEnter()
          this.spinning = false
        })
      }
    },
    nextRoute(routerPush) {
      if (routerPush != null) {
        if (checkEnv.locationReturned()) {
          return;
        }
        if (location.href.indexOf("?accessToken=") > 0) {
          window.location.replace(
            `${location.href.split('?')[0]}#/${routerPush}`
          )
          return;
        }
        this.$router.push(routerPush);
      }
    },
    getImgCode(focus) {
      user.getImgCode().then(res => {
        this.codeImg = 'data:image/jpeg;base64,' + res.msg
        this.form.setFieldsValue({ imageCode: '' })
        if (focus) {
          this.$refs.imgCodeRef.focus()
        }
        this.sendSuccess = false
      })
    },
    changeType(num) {
      this.loginType = num
      this.form.resetFields()
      if (num == 1) {
        this.getImgCode()
      }
    },
    back() {
      this.mode = 'login'
      this.form.resetFields()
      this.showForget = false
    },
    fotgetPwd() {
      this.mode = 'reset_password'
      this.form.resetFields()
      this.form.setFieldsValue({
        mobile: null,
        smsCode: null,
        password: null,
        repeatPassword: null,
        imageCode: null
      })
      this.showForget = true
      this.getImgCode()
    },
    confirmUpdate() {
      this.form.validateFields((err, value) => {
        if (!err) {
          if (value.password != value.repeatPassword) {
            this.$message.error('两次密码输入值不同，请确认密码')
          } else {
            delete value.repeatPassword
            let params = {
              mobile: value.mobile,
              smscode: value.smsCode,
              password: value.password,
              imageCode: value.imageCode
            }
            user.updatePasswordByMobile(params).then(res => {
              this.$message.success('修改成功')
              this.back()
            })
          }
        }
      })
    },
  },
  mounted() {

  },
  created() {
    if (checkEnv.locationChanged()) return;
    bureau.getBureauId().then((res) => {
      console.log(res, '哈哈哈')
      this.bureauId = res
      console.log(this.bureauId, '哈哈哈')
    }).finally(() => {
      if (this.bureauId == -11111111) {
        console.log('finally')
        this.bureauId = null
      }
    })
    bureau.getBureau().then(res => {
      console.log(res, 'getBureau');
      this.bureauName = res.bureauName
    })
    //清空缓存
    console.log('login')
    this.$store.commit('CLEARLOGIN')
    // console.log('this.$route.params.mode', this.$route.params.mode)
    if (this.$route.params.mode == undefined) {
      this.mode = 'login'
    } else {
      this.mode = this.$route.params.mode
    }
    this.$ls.clear('bureauId')
    if (
      location.search.split('accessToken=') &&
      location.search.split('accessToken=').length > 1
    ) {
      this.spinning = true
      this.doLogin()
    }
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.login-outer {
  background: #ebf2ff;
  height: 100vh;
  margin: 0px auto;
  text-align: center;

  .login-inner {
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    >div {
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.login-left {
  img {
    width: 600px;
    height: auto;
  }
}

.login-right {
  border-radius: 8px;
  margin: 0px auto;
  width: 400px;
  text-align: center;
  background: white;
  padding: 44px 36px 24px;

  .logo {
    width: 72px;
    height: auto;
  }

  .desc {
    margin-top: 10px;
    color: #151617;
    font-size: 18px;
    font-weight: 600;
  }
}

.login-form {
  margin-top: 30px;
  width: 100%;
}

.login-input-text {
  height: 40px;
}

.login-button {
  width: 100%;
}

.getCaptcha {
  display: block;
  width: 100%;
  height: 40px;
}

.login-type-but {
  text-align: left;
  color: $primary-color-dark;
  padding-left: 2px;
  cursor: pointer;
}

.institution-register {
  cursor: pointer;
  text-align: right;
  color: $normal-color-dark;
  font-size: 14px;
}

.mistake-prompt {
  // display: flex;
  // justify-content: center;
  width: 328px;
  text-align: center;
  margin: 20px auto 82px auto;
  color: #000;
  font-size: 20px;
  font-weight: 300;
  border: 1px solid rgb(201, 201, 202);
  padding: 30px 10px;
  box-sizing: border-box;
  border-radius: 15px;

  .domain-name {
    font-weight: 500;
  }
}

.img-code {
  display: flex;
  align-items: center;
}

.pic {
  height: 40px;
  margin: 0 12px;
  transform: translateY(-1px);

  img {
    width: 80px;
    height: 40px;
    border-radius: 4px;
  }
}

.width2 {
  width: 500px;
}

.w302 {
  width: 302px;
}
</style>
